/**
 * Figma Node IDs:
 * Design Frame: 5312:16703
 * Instance IDs: I381:53042;1:7822, I381:53042;1:7823, I381:53067;1:8022, I381:53067;48:4235, I5312:16677;1:7822, I5312:16677;1:7823, I5312:16678;1:8022, I5312:16678;48:4235
 * Composite: true
 * Last Updated: 2026-02-19
 * Generated by: Claude Code figma-component command
 */
import * as React from "react";
import { useIntl, defineMessages } from "react-intl";

import { LxButton } from "../LxButton";
import { ButtonType } from "../LxButton/constants";

import * as styles from "./BackAndForthSlab.css";

const messages = defineMessages({
  previousSection: {
    id: "back_and_forth_slab.previous_section",
    defaultMessage: "Previous section",
    description: "Default label for previous section button",
  },
  nextSection: {
    id: "back_and_forth_slab.next_section",
    defaultMessage: "Next section",
    description: "Default label for next section button",
  },
});

export interface BackAndForthSlabProps {
  onPreviousClick?: () => void;
  onNextClick?: () => void;
  className?: string;
  testId?: string;
  previousLabel?: string;
  nextLabel?: string;
  showPrevious?: boolean;
  showNext?: boolean;
  previousDisabled?: boolean;
  nextDisabled?: boolean;
  previousButtonVariant?: ButtonType;
  nextButtonVariant?: ButtonType;
}

export const BackAndForthSlab: React.FC<BackAndForthSlabProps> = ({
  onPreviousClick,
  onNextClick,
  className,
  testId,
  previousLabel,
  nextLabel,
  showPrevious = true,
  showNext = true,
  previousDisabled = false,
  nextDisabled = false,
  previousButtonVariant = "ghost",
  nextButtonVariant = "primary",
}) => {
  const intl = useIntl();

  const previousText =
    previousLabel || intl.formatMessage(messages.previousSection);
  const nextText = nextLabel || intl.formatMessage(messages.nextSection);

  const containerClassName = [
    styles.slabContainer,
    !showPrevious && showNext
      ? styles.singleButtonContainer.next
      : showPrevious && !showNext
        ? styles.singleButtonContainer.previous
        : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  if (!showPrevious && !showNext) {
    return null;
  }

  return (
    <nav
      className={containerClassName}
      aria-label="Section navigation"
      data-testid={testId}
    >
      {showPrevious && (
        <div className={styles.buttonWrapper}>
          <LxButton
            variant={previousButtonVariant}
            size="large"
            text={previousText}
            trailingIcon="back"
            onClickHandler={onPreviousClick}
            disabled={previousDisabled}
            testId={testId ? `${testId}-previous` : undefined}
          />
        </div>
      )}
      {showNext && (
        <div className={styles.buttonWrapper}>
          <LxButton
            variant={nextButtonVariant}
            size="large"
            text={nextText}
            trailingIcon="next"
            onClickHandler={onNextClick}
            disabled={nextDisabled}
            testId={testId ? `${testId}-next` : undefined}
          />
        </div>
      )}
    </nav>
  );
};

export default BackAndForthSlab;
